<template>
  <Day day="19.12.2025">
    <div slot="page-content">
      <h3>Friends Time 🫶</h3>
      <p>
        <img src="@/assets/day19.jpeg"/>
      </p>
    </div>
  </Day>
</template>

<script>
import Day from '../Day.vue'

export default {
  name: 'Day19',
  components: {
    Day
  }
}
</script>
